import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hasMadelinContracts", "optionsContainer", "madelinStatementsOption"];

  hasMadelinContractsChecked() {
    this.hasMadelinContractsTarget.checked = true;
  }

  enableOptions() {
    this.optionsContainerTarget.classList.remove("hidden");
  }

  disableOptions() {
    this.optionsContainerTarget.classList.add("hidden");
    this.madelinStatementsOptionTargets.forEach((option) => (option.checked = false));
  }
}
